import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';

const CancelarPagoSubscripcion  = () => {
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    Swal.fire({
      icon: 'info',
      title: 'Pago cancelado',
      text: 'Has cancelado el pago. No se ha creado la cuenta de tutor.',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      localStorage.removeItem("tutorPendiente");
      setMensaje("Has cancelado el pago. Tu cuenta de tutor no ha sido creada.");
    });
  }, []);

  return (
    <div style={{ 
            display: 'flex',                 
            flexDirection: 'column',  
            minHeight: 'calc(100vh - 100px)', 
            paddingTop: '60px', 
            background: 'var(--bg-home)',
            color: 'var(--text-principal)',
            justifyContent: 'center',
            alignItems: 'center'
            }} 
    >
      <h2>Pago cancelado</h2>
      <p>{mensaje}</p>
      <button style={{
        display: 'inline-block',
        marginTop: '1rem',
        padding: '0.6rem 1.2rem',
        background: 'var(--botonAzul)',
        color: '#fff',
        borderRadius: '6px',
        textDecoration: 'none',
        fontWeight: 500,
        transition: 'background-color 0.2s, transform 0.1s'
      }} onClick={() => { window.location.href = "/"; }}>Volver al inicio</button>
    </div>
  );
};

export default CancelarPagoSubscripcion;